export enum IosCategoryIdentifier {
    ACCEPT_DECLINE = 'ab_cat_accept_decline',
    YES_NO = 'ab_cat_yes_no',
    CONFIRM_CANCEL = 'ab_cat_confirm_cancel',
    MORE = 'ab_cat_more',
}
